import {
  handleDownloadDPSRAKRoutes,
  handleDownloadDPSSHJSNRRoutes,
  handleDownloadDPSSHJSNRDD,
  handleDownloadDPSSHJPRIDD,
  handleDownloadTraAgrFormRAK,
  handleDownloadTraAgrForm,
  handleDownloadASBT,
  handleDownloadNBT,
  handleDownloadSTAFFASBT,
  handleDownloadSTAFFNBT,
  handleDUBAIBUSROUTES,
  handleDUBAIDRIVERDETAILS,
  handleTransportAlsaraya,
  handleAgreementAlsaraya,
} from "hooks/downloads";

export const navConfigDrawer = [
  {
    title: "About Us",
    path: "/about-us",
  },

  {
    title: "Our Services",
    path: "/services/service-summary",
  },

  {
    title: "Bus Route DPS Dubai",
    action: handleDUBAIDRIVERDETAILS,
  },
  {
    title: "Bus Route DPS Dubai (Smart Search)",
    path: "/services/bus-routes/search",
  },
  {
    title: "Driver Details DPS Dubai",
    action: handleDUBAIDRIVERDETAILS,
  },
  {
    title: "Fee Details",
    path: "/fees/details",
  },

  {
    title: "Parents Agreement Form DPS Dubai",
    // action: handleDownloadTraAgrForm,
    path: "https://firebasestorage.googleapis.com/v0/b/alsaraya-d8bd7.appspot.com/o/pdf%2FAlsaraya-PDS-Dubai-Transport-Agreement.pdf?alt=media&token=bbc8d546-015c-4378-bef4-a4da5d5ea801",
  },
  {
    title: "Transport Form",
    // action: handleDownloadTraAgrForm,
    path: "https://firebasestorage.googleapis.com/v0/b/alsaraya-d8bd7.appspot.com/o/pdf%2Ftransport-form-alsaraya.pdf?alt=media&token=5497a734-127b-4f26-bf40-a9ef49a39e14",
  },
  {
    title: "Payment Details",
    path: "/fees/payment-modes",
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
];

export const navConfig = [
  {
    title: "About Us",
    path: "/about-us",
  },
  {
    title: "Services",
    path: "/services",
    children: [
      {
        title: "Our Services",
        path: "/services/service-summary",
      },
      {
        title: "Bus Route Details",
        path: "",
        children: [
          {
            title: "DPS Sharjah Primary",
            action: handleDUBAIBUSROUTES,
          },
          {
            title: "DPS Sharjah Senior",
            action: handleDownloadDPSSHJSNRRoutes,
          },
          {
            title: "DPS RAK",
            action: handleDownloadDPSRAKRoutes,
          },
        ],
      },
      {
        title: "Driver Details Download",
        path: "",
        children: [
          {
            title: "DPS Sharjah Primary",
            action: handleDownloadDPSSHJPRIDD,
          },
          {
            title: "DPS Sharjah Senior",
            action: handleDownloadDPSSHJSNRDD,
          },
          // {
          //   title: "DPS RAK",
          //   action: handleDownloadDPSRAKDRIVERDETAILS,
          // },
        ],
      },
    ],
  },
  {
    title: "Fees",
    path: "/fees",
    children: [
      {
        title: "Fee Details",
        path: "/fees/details",
      },
      {
        title: "NBT Parents Agreement Form",
        path: "",
        children: [
          {
            title: "DPS Sharjah Primary",
            action: handleDownloadTraAgrForm,
          },
          {
            title: "DPS Sharjah Senior",
            action: handleDownloadTraAgrForm,
          },
          {
            title: "DPS RAK",
            action: handleDownloadTraAgrFormRAK,
          },
        ],
      },
      {
        title: "Payment Details",
        path: "/fees/payment-modes",
      },
    ],
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
];

export const navconfigNew = (navigate) => {
  return [
    {
      label: "Home",
      path: "/",
    },
    {
      label: "Our Services",
      path: "/services",
      items: [
        {
          label: "School transportation",
          path: "/transport",
          callback: () => navigate("/services/transport"),
        },
        {
          label: "Vehicle Maintenance",
          path: "/maintance",
          callback: () => navigate("/services/maintenance"),
        },
      ],
    },
    {
      label: "Bus Routes",
      path: "",
      items: [
        {
          label: "Bus Routes Map",
          callback: handleDUBAIBUSROUTES,
          // [
          //   { label: "Primary Section", callback: handleDUBAIBUSROUTES },
          //   { label: "Senior Section", callback: handleDownloadDPSSHJSNRRoutes },
          // ],
        },
        {
          label: "DPS Dubai (Smart Search)",
          path: "/services/bus-routes/search",
          callback: () => navigate("/services/bus-routes/search"),
        },
        // {
        //   label: "DPS RAK",
        //   callback: handleDownloadDPSRAKRoutes,
        // },
        {
          label: "Driver Details",
          items: [
            {
              label: "DPS Dubai",
              callback: handleDUBAIDRIVERDETAILS, // --uncommect this*****************
              // callback: () => navigate("/bus-routes/driver-details-dps-dubai"),
              // [
              //   { label: "Primary Section", callback: handleDownloadDPSSHJPRIDD },
              //   { label: "Senior Section", callback: handleDownloadDPSSHJSNRDD },
              // ],
            },
            // {
            //   label: "DPS RAK",
            //   callback: handleDownloadDPSRAKDRIVERDETAILS,
            // },
          ],
        },
        {
          label: "FAQs",
          path: "/faq/logistics",
          callback: () => navigate("/faq/logistics"),
        },
      ],
    },
    {
      label: "Forms",
      path: "",
      items: [
        {
          label: "Transport form",
          callback: handleTransportAlsaraya,
        },
        // {
        //   label: "Transport form for staff - NBT",
        //   callback: handleDownloadSTAFFNBT,
        // },
      ],
    },
    {
      label: "Fees",
      path: "/fees",
      items: [
        {
          label: "Fee Details",
          path: "/details",
          callback: () => navigate("/fees/details"),
        },
        {
          label: "Al Saraya Parents Agreement Form",
          callback: handleAgreementAlsaraya,
        },
        {
          label: "FAQs",
          path: "/faq/fees",
          callback: () => navigate("/faq/fees"),
        },
      ],
    },
    {
      label: "Careers",
      path: "/careers/list",
      callback: () => navigate("/careers/list"),
    },
  ];
};
